import React, { useState, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Button, CardActions, CardHeader, Chip, FormControl, IconButton, InputAdornment, MenuItem, Switch, TextField, Tooltip } from '@mui/material';
import { EyeIconButton } from '../../../../assets/common-svg/CommonSvg';
import { useNavigate } from 'react-router';
import ListIcon from '@mui/icons-material/List';
import { useDispatch, useSelector } from 'react-redux';
import { allModules, allProcessLists, disableIsReadonly, disableModule, disableProcess, emptyallProcessListsById, enableIsReadonly, enableModule, enableProcess, fetchAllModules, fetchAllProcessList, updateProcess } from '../../../slices/help';
import SelectField from '../../../components/styled/SelectField';
import NoDataCard from '../../../components/NoDataCard';
import { SearchIcon } from '../../../assets/CommonSvg';
import { debounce } from 'lodash';
const DEBOUNCE_DELAY = 300;

function Help() {

    const [value, setValue] = useState('');
    const [switchStates, setSwitchStates] = React.useState({});
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const allModule = useSelector(allModules);

    const [moduleType, setModuleType] = useState("")
    const parentIds = new Set(allModule.map(mod => mod.parent_id).filter(Boolean));
    const moduleOptions = allModule
        .filter(mod => !(mod.parent_id === null && parentIds.has(mod.id))) // remove parents with children
        .map(mod => {
            if (mod.parent_id !== null) {
                const parent = allModule.find(item => item.id === mod.parent_id);
                return {
                    value: mod.id,
                    label: `${parent?.name} - ${mod.name}`,
                };
            } else {
                return {
                    value: mod.id,
                    label: mod.name,
                };
            }
        });
      
    const processList = useSelector(allProcessLists)

    const formOptions = [
        {
            type: 'select',
            name: 'module',
            placeholder: 'All Modules',
            options: moduleOptions
        },
    ]

    const handleSearch = (e) => {
        setValue(e)
    }
    const handleChange = (id) => (event) => {
        const newStatus = event.target.checked;
        setSwitchStates((prev) => ({
            ...prev,
            [id]: newStatus,
        }));

        const payload = {
            help_process_id: id,
            status: newStatus ? 1 : 0,
        };

        dispatch(updateProcess(payload));
    };


    const handleCreateHelp = async () => {
        await dispatch(disableModule([]))
        await dispatch(disableProcess([]))
        await dispatch(disableIsReadonly())
        navigate("/bmr/faq/create");
    };

    const handleViewListing = async (module, process, id) => {
        let proc_obj = { name: process, id: id }
        await dispatch(enableModule(module))
        await dispatch(enableProcess(proc_obj))
        await dispatch(emptyallProcessListsById())
        await dispatch(enableIsReadonly())
        navigate('/bmr/faq/listing')
    }

    const handleViewFaq = async (id) => {
        navigate('/bmr/faq/view', { state: { processId: id } });
      };
      
  // Memoized debounced search
  const debouncedSearch = useMemo(
    () => debounce(handleSearch, DEBOUNCE_DELAY),
    [handleSearch]
  );

    useEffect(() => {
        dispatch(fetchAllProcessList(moduleType || value ? { id: moduleType , search:value} : {}));
    }, [moduleType, value]);


    useEffect(() => {
        if (processList && processList.length > 0) {
            const initialSwitchStates = {};
            processList.forEach((card) => {
                initialSwitchStates[card.id] = card.status === 1;
            });
            setSwitchStates(initialSwitchStates);
        }
                dispatch(fetchAllModules());
        
    }, [processList]);


    return (

        <div className="p-3">
            <div className="flex justify-between items-center mb-4">
                <div className='w-96'>
                    <TextField

                        className="bg-[#fff] w-[325px] py-[2.5px] border-0 rounded-[10px]"
                        size="small"
                        placeholder={"Search Processing"}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon className="text-gray-500" />
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            backgroundColor: "white",
                            color: "black",
                            "& input::placeholder": {
                                color: "#777777",
                                opacity: 1,
                            },
                            "& fieldset": { border: 'none' },
                            height: "45px",
                            borderRadius: "0.75rem",
                        }}
                        onChange={(e) => debouncedSearch(e.target.value)}
                    />
                </div>
                <div className="ml-4 flex gap-3">
                    <Button className="ml-2" onClick={() => handleCreateHelp()}>Add New FAQ</Button>
                    <FormControl variant={"standard"}>
                        <div className="w-100 flex gap-2 align-items-center select-module">
                             <SelectField
                                value={moduleType}
                                onChange={(e) => {
                                    setModuleType(e.target.value)
                                }}
                                sx={{
                                    '& .MuiSelect-select span::before': {
                                        color: '#808080',
                                        content: `"${formOptions[0].placeholder || '-- Select --'}"`,
                                    }
                                }}
                                  
                            >
                                <MenuItem value="" ><em>{formOptions[0].placeholder || 'Select'}</em></MenuItem>
                                {formOptions[0].options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </SelectField> 
                        </div>
                    </FormControl>

                </div>
            </div>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: processList.length > 0 ? 'repeat(3, 1fr)' : '1fr',
                    gap: 2,
                }}
            >
                {processList.length > 0 ?
                    processList.map((card, index) => (
                        <Card className="rounded-xl  w-100" key={index}>
                            <CardHeader
                                action={
                                    <IconButton aria-label="settings">
                                <Tooltip title="status" >

                                        <Switch
                                            // checked={switchStates[card.id] || false}
                                            checked={switchStates[card.id] !== false}
                                            onChange={handleChange(card.id)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#3571FF', // custom blue
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#3571FF',
                                                },
                                            }}
                                            />
                                            </Tooltip>
                                    </IconButton>
                                }
                                title={card?.process_name}
                            />
                            <CardContent>
                                <Chip
                                    label={card?.module?.name}
                                    color="success"
                                />
                            </CardContent>
                            <hr className="ml-3 mr-3" />
                            <CardActions className="p-3 flex justify-between">
                                <Tooltip title="FAQ's Listing" >
                                    <Button
                                        color="primary"
                                        variant="outlined"
                                        onClick={() =>
                                            handleViewListing(card?.module, card?.process_name, card?.id)
                                        }
                                        size="small"
                                    >
                                        <ListIcon />
                                    </Button>
                                </Tooltip>
                                <Tooltip title="View">
                                    <span>
                                        <IconButton onClick={() =>
                                            handleViewFaq(card?.id)
                                        }>
                                            <EyeIconButton
                                                bgColor={"#3571FF"}

                                            />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </CardActions>
                        </Card>
                    ))
                    : <Box > <NoDataCard />
                    </Box>
                }
            </Box>
        </div>

    );
}

export default Help;
